"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcFormColorPicker = void 0;
var react_1 = __importDefault(require("react"));
var react_bootstrap_1 = require("react-bootstrap");
var react_color_1 = require("react-color");
var AcFormColorPicker_module_scss_1 = __importDefault(require("./AcFormColorPicker.module.scss"));
var AcFormFieldBadge_1 = require("./AcFormFieldBadge");
/**
 * Color Picker with dropdown
 */
var AcFormColorPicker = function (_a) {
    var color = _a.color, required = _a.required, onChange = _a.onChange;
    var setColorFunction = function (_color) {
        onChange(_color);
    };
    var onChangeComplete = function (colorResult) {
        setColorFunction(colorResult.hex.toUpperCase());
    };
    var onInputChange = function (e) {
        setColorFunction(e.target.value);
    };
    var CustomMenu = react_1.default.forwardRef(function (_a, ref) {
        var _style = _a.style, className = _a.className;
        return (react_1.default.createElement("div", { ref: ref, style: _style, className: className },
            react_1.default.createElement(react_color_1.TwitterPicker, { color: color, triangle: "hide", onChangeComplete: onChangeComplete })));
    });
    // the bootstrap component was finicky to work with, so I ended up using many inline styles
    // className styles did not have an effect in some cases
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(react_bootstrap_1.InputGroup, null,
            react_1.default.createElement(react_bootstrap_1.InputGroup.Prepend, { className: AcFormColorPicker_module_scss_1.default.colorBorder + " " },
                react_1.default.createElement(react_bootstrap_1.InputGroup.Text, { style: {
                        fontSize: '2rem',
                        color: color,
                        background: 'white',
                        padding: '0 0.3rem 0.2rem 1rem',
                    } }, "\u25A0")),
            react_1.default.createElement(react_bootstrap_1.FormControl, { style: { borderLeftStyle: 'none', paddingLeft: '0.3rem' }, value: color, onChange: onInputChange }),
            react_1.default.createElement(react_bootstrap_1.Dropdown, { as: react_bootstrap_1.InputGroup.Append, title: "", id: "color-picker-dropdown" },
                required && (react_1.default.createElement(react_bootstrap_1.InputGroup.Text, null,
                    react_1.default.createElement(AcFormFieldBadge_1.AcFormFieldBadge, null))),
                react_1.default.createElement(react_bootstrap_1.Dropdown.Toggle, { id: "color-picker-dropdown-toggle", style: {
                        backgroundColor: 'white',
                        color: '#b2cae1',
                        borderStyle: 'none none none solid',
                        borderColor: '#b2cae1',
                    } },
                    react_1.default.createElement("i", { className: "fas fa-caret-down " + AcFormColorPicker_module_scss_1.default.dropdownIcon + " " })),
                react_1.default.createElement(react_bootstrap_1.Dropdown.Menu, { as: CustomMenu })))));
};
exports.AcFormColorPicker = AcFormColorPicker;
exports.AcFormColorPicker.displayName = 'AcFormColorPicker';
//# sourceMappingURL=AcFormColorPicker.js.map